import React, { useEffect, useRef, useState } from 'react';
import { Link, useLocation } from 'react-router-dom';

const NavBar = () => {
    const location = useLocation();
    const [logoSize, setLogoSize] = useState({ height: '60px', width: '250px' });
    const [isMenuOpen, setIsMenuOpen] = useState(false);
    const dropdownRef = useRef(null);
    const buttonRef = useRef(null); 

    const isActiveRoute = (path) => {
        return location.pathname === path;
    };

    const handleResize = () => {
        if (window.innerWidth < 640) {
            setLogoSize({ height: '48px', width: 'auto' });
        } else {
            setLogoSize({ height: '60px', width: '225px' });
        }
    };

    const handleCloseMenu = () => {
        setIsMenuOpen(false);
    };

    useEffect(() => {
        window.addEventListener('resize', handleResize);
        handleResize();

        return () => {
            window.removeEventListener('resize', handleResize);
        };
    }, []);

    useEffect(() => {
        const handleClickOutside = (event) => {
            if (
                dropdownRef.current &&
                !dropdownRef.current.contains(event.target) &&
                buttonRef.current &&
                !buttonRef.current.contains(event.target)
            ) {
                setIsMenuOpen(false);
            }
        };

        document.addEventListener('mousedown', handleClickOutside);
        return () => {
            document.removeEventListener('mousedown', handleClickOutside);
        };
    }, []);

    const toggleMenu = () => {
        setIsMenuOpen((prevState) => !prevState);
    };

    return (
        <nav className="fixed top-0 left-0 right-0 bg-white shadow-md z-50">
            <div className="max-w-7xl mx-auto px-6 py-4 flex justify-between items-center">
                <div className="flex items-center">
                    <Link to="/" className="flex items-center no-underline">
                        <img src="https://i.imgur.com/UcvWOy3.png" alt="Logo" style={logoSize} />
                    </Link>
                </div>
                <div className="flex items-center md:hidden relative">
                    <button
                        ref={buttonRef} 
                        onClick={toggleMenu}
                        className="text-gray-700 focus:outline-none"
                    >
                        <svg xmlns="http://www.w3.org/2000/svg" className="h-6 w-6" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M4 6h16M4 12h16m-7 6h7" />
                        </svg>
                    </button>
                    {isMenuOpen && (
                        <div
                            ref={dropdownRef}
                            className="fixed top-16 left-0 right-0 bg-white shadow-lg z-50 overflow-y-hidden"
                        >
                            <div className="flex justify-between items-center px-6 py-2"></div>
                            <div className="py-2">
                                <Link
                                    to="/aanbod"
                                    className={`block px-6 py-3 text-gray-700 hover:bg-blue-600 hover:text-white ${isActiveRoute('/aanbod') ? 'font-bold' : ''}`}
                                    onClick={handleCloseMenu}
                                >
                                    Aanbod
                                </Link>
                                <Link
                                    to="/overons"
                                    className={`block px-6 py-3 text-gray-700 hover:bg-blue-600 hover:text-white ${isActiveRoute('/overons') ? 'font-bold' : ''}`}
                                    onClick={handleCloseMenu}
                                >
                                    Over ons
                                </Link>
                                <Link
                                    to="/contact"
                                    className={`block px-6 py-3 text-gray-700 hover:bg-blue-600 hover:text-white ${isActiveRoute('/contact') ? 'font-bold' : ''}`}
                                    onClick={handleCloseMenu}
 >
                                    Contact
                                </Link>
                                <Link
                                    to="/Veelgesteldevragen"
                                    className={`block px-6 py-3 text-gray-700 hover:bg-blue-600 hover:text-white ${isActiveRoute('/Veelgesteldevragen') ? 'font-bold' : ''}`}
                                    onClick={handleCloseMenu}
                                >
                                    Veel gestelde vragen
                                </Link>
                                
                            </div>
                        </div>
                    )}
                </div>
                <div className="hidden md:flex items-center space-x-8 ml-8">
                    <Link
                        to="/aanbod"
                        className={`font-medium text-base transition-colors duration-200 no-underline ${isActiveRoute('/aanbod')
                            ? 'text-blue-600'
                            : 'text-gray-700 hover:text-blue-600'
                            }`}
                    >
                        Aanbod
                    </Link>
                    <Link
                        to="/overons"
                        className={`font-medium text-base transition-colors duration-200 no-underline ${isActiveRoute('/overons')
                            ? 'text-blue-600'
                            : 'text-gray-700 hover:text-blue-600'
                            }`}
                    >
                        Over ons
                    </Link>
                    <Link
                        to="/contact"
                        className={`font-medium text-base transition-colors duration-200 no-underline ${isActiveRoute('/contact')
                            ? 'text-blue-600'
                            : 'text-gray-700 hover:text-blue-600'
                            }`}
                    >
                        Contact
                    </Link>
                    <Link
                        to="/Veelgesteldevragen"
                        className={`font-medium text-base transition-colors duration-200 no-underline ${isActiveRoute('/Veelgesteldevragen') ? 'text-blue-600' : 'text-gray-700 hover:text-blue-600'}`}
                    >
                        Veel gestelde vragen
                    </Link>
                </div>
            </div>
        </nav>
    );
};

export default NavBar;